/* eslint-disable max-len */
import type { FC } from 'react';

import { colorCssVar } from 'utils/colorCssVar';
import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SuccessFilledIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
        fill={colorCssVar('borderStrong')}
        fillRule="evenodd"
      />
      <circle cx="16" cy="16" fill={colorCssVar('iconSuccess')} r="10" />
      <path
        d="M21.3136 11.9069C20.9231 11.5164 20.2899 11.5164 19.8994 11.9069L14.2425 17.5638L12.1211 15.4425C11.7306 15.052 11.0975 15.052 10.7069 15.4425C10.3164 15.833 10.3164 16.4662 10.7069 16.8567L13.5355 19.6853C13.8479 19.9976 14.3177 20.0669 14.7059 19.9129C14.9232 19.8326 15.1316 19.6832 15.2426 19.4853L21.3136 13.4142C21.7041 13.0237 21.7041 12.3906 21.3136 11.9069Z"
        fill={colorCssVar('background')}
      />
    </BaseIcon>
  );
};
